import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/public/Home";
import ServicesPage from "@/pages/public/Services";
import ServiceModelsPage from "@/pages/public/ServiceModels";
import AIInDeliveryPage from "@/pages/public/AIInDelivery";
import EngagePage from "@/pages/public/Engage";
import JoinNetworkPage from "@/pages/public/JoinNetwork";
import ContactPage from "@/pages/public/Contact";
import PrivacyPolicyPage from "@/pages/public/PrivacyPolicy";

import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminCandidates from "@/pages/admin/Candidates";
import AdminEnquiries from "@/pages/admin/Enquiries";
import AdminContacts from "@/pages/admin/Contacts";
import AdminUsers from "@/pages/admin/Users";
import AdminCMS from "@/pages/admin/CMS";
import AdminEmailTemplates from "@/pages/admin/EmailTemplates";
import AdminDataManagement from "@/pages/admin/DataManagement";
import AdminSecurity from "@/pages/admin/Security";
import AdminPrivacyPolicy from "@/pages/admin/PrivacyPolicy";
import AdminForgotPassword from "@/pages/admin/ForgotPassword";
import AdminResetPassword from "@/pages/admin/ResetPassword";
import AdminAccount from "@/pages/admin/Account";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/service-models" element={<ServiceModelsPage />} />
            <Route path="/ai-delivery" element={<AIInDeliveryPage />} />
            <Route path="/engage" element={<EngagePage />} />
            <Route path="/join-network" element={<JoinNetworkPage />} />
            <Route path="/careers" element={<Navigate to="/join-network" replace />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin/account" element={<ProtectedRoute><AdminAccount /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/candidates" element={<ProtectedRoute><AdminCandidates /></ProtectedRoute>} />
            <Route path="/admin/enquiries" element={<ProtectedRoute><AdminEnquiries /></ProtectedRoute>} />
            <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute requireAdmin><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/cms" element={<ProtectedRoute requireAdmin><AdminCMS /></ProtectedRoute>} />
            <Route path="/admin/email-templates" element={<ProtectedRoute requireAdmin><AdminEmailTemplates /></ProtectedRoute>} />
            <Route path="/admin/data-management" element={<ProtectedRoute requireAdmin><AdminDataManagement /></ProtectedRoute>} />
            <Route path="/admin/security" element={<ProtectedRoute requireAdmin><AdminSecurity /></ProtectedRoute>} />
            <Route path="/admin/privacy-policy" element={<ProtectedRoute requireAdmin><AdminPrivacyPolicy /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
